module.exports = __webpack_public_path__ + "static/media/truck.9eb2df51.svg";